import AxiosService from "@/services/AxiosService";
import IBrandServiceAdmin from "@/services/definition/IBrandServiceAdmin";
import BrandCreate from "@/models/brand/BrandCreate";
import ICreateResponse from "@/models/ICreateResponse";
import Vue from "vue";
import BrandListFilter from "@/models/brand/BrandListFilter";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import IPaginatedResponse from "@/models/IPaginatedResponse";
import {IBrandAdmin, IBrandAdminListEntry} from "@/models/brand/BrandAdminModels";
import BrandUpdate from "@/models/brand/BrandUpdate";

export default class AxiosBrandServiceAdmin extends AxiosService implements IBrandServiceAdmin {

	public static readonly BASE_URL = '/admin/brands';
	public static readonly BASE_URL_COMMON = '/brands';

	protected defineBaseUrl(): string {
		return AxiosBrandServiceAdmin.BASE_URL;
	}

	public brand(id: string): Promise<IBrandAdmin> {
		return Vue.$axios.get<IBrandAdmin>(this.url(id)).then(res => res.data);
	}

	public brands(filter: BrandListFilter | null, options: AsiListTableOptions | null): Promise<IPaginatedResponse<IBrandAdminListEntry>> {
		const opt = new AsiListTableOptions();
		opt.sortBy = options !== null ? options.sortBy : ['name'];
		opt.sortDesc = options !== null ? options.sortDesc : [false];
		opt.page = options !== null ? options.page : 1;
		opt.itemsPerPage = options !== null ? options.itemsPerPage : 0;

		return Vue.$axios.get<IPaginatedResponse<IBrandAdminListEntry>>(this.url(), {
			params: {
				...filter,
				...opt
			}
		}).then(res => res.data);
	}

	public uploadBrandImage(id: string, file: File): Promise<null> {
		const formData = new FormData();
		formData.append('image', file);

		return Vue.$axios.put(
			this.url(`${id}/image`, AxiosBrandServiceAdmin.BASE_URL_COMMON),
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}
		).then(res => res.data);
	}

	public create(model: BrandCreate): Promise<ICreateResponse> {
		return Vue.$axios.post(this.url(null, AxiosBrandServiceAdmin.BASE_URL_COMMON), model)
			.then(res => res.data);
	}

	public update(id: string, model: BrandUpdate): Promise<null> {
		return Vue.$axios.put(this.url(id, AxiosBrandServiceAdmin.BASE_URL_COMMON), model).then(res => res.data);
	}

	public delete(id: string): Promise<null> {
		return Vue.$axios.delete(this.url(id, AxiosBrandServiceAdmin.BASE_URL_COMMON)).then(res => res.data);
	}
}
